import React from "react";
import { publicKey } from "../../utils/globalConstant";
import { toast } from "react-toastify";
import { usePaystackPayment } from "react-paystack";
import { verifyPayment } from "./api";

const PayStack = ({ config, onClick, disabled, children, className }) => {
  const configuration = { ...config, publicKey: publicKey };
  const initializePayment = usePaystackPayment(configuration);

  const onSuccess = (reference) => {
    const ref = reference.reference;
    (async () => {
      const response = await verifyPayment(ref);
      if (response) {
        toast.success("Payment Successful");
        onClick(response);
      }
    })();
  };
  const onClose = () => {
    toast.error("Payment Failed");
  };

  return (
    <>
      <button
        disabled={disabled}
        onClick={() => initializePayment(onSuccess, onClose)}
        className={className}
      >
        {children}
      </button>
    </>
  );
};

export default PayStack;
